// @ts-nocheck
 
 
 
 
 
/* eslint-disable import/order */
 
 
 
/* eslint-disable react/jsx-newline */
 
 
 
 
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';
import  BanksTable  from './bankTable';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';
import AddBanks from './addBank';
import EditBanks from './updateBank';
import ViewBanks from './view-bank';

const Banks: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const hasBanksAddAccess = useTypedSelector(state =>
    hasWriteAccessToMasterConfigSubSystem(state, 'Banks')
  );

  return (
    <CardContainer>
      <Switch>
        <Route path={`${baseURL}/new`}>
          {hasBanksAddAccess ? <AddBanks/> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/:id/edit`}>
        {hasBanksAddAccess ? <EditBanks/> : <NotAuthorized />}
        </Route>
        <Route path={`${baseURL}/:id`}>
         <ViewBanks/>
        </Route>
        <Route exact path={`${baseURL}`}>
          <BanksTable/>
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { Banks };
